import axios from "axios"
import { cleanStore, clearMultibase, setAIBase, setAIBaseRequestSuccess } from "../actions/multiAiBase"
import { clearLocalStorage } from "../utils"
const baseUrl = window._env_.REACT_APP_API_URL
import store from "../store"
import { logoutClearStore, logoutUser, logoutUserAction, updateToken } from "../actions/userActions"
import { setIsFileDeleted } from "../actions/deleteActions"
let refreshingToken = null

const Request = axios.create({
	baseURL: baseUrl,
})

export const getNewAIBaseToken = (id) => {
	return Request.get(`/auth/${id}`)
}

Request.interceptors.request.use(
	(config) => {
		const user = JSON.parse(localStorage.getItem("user"))
		const token = user ? user?.token?.access_token : undefined
		const refreshToken = user ? user?.token?.refresh_token : undefined
		if (token || refreshToken) {
			config.headers.common["Authorization"] = config?.url?.includes("refresh-token") ? `Bearer ${refreshToken}` : `Bearer ${token}`
			config.headers.common["auth_token"] = config?.url?.includes("refresh-token") ? refreshToken : token
			config.headers.common["auth-token"] = config?.url?.includes("refresh-token") ? refreshToken : token
		}
		config.headers.common["Content-Type"] = "application/json"
		config.headers.common["accept"] = "application/json"

		if (config.data instanceof FormData) {
			config.headers["Content-Type"] = "multipart/form-data"
		}

		return config
	},
	(error) => {
		Promise.reject(error)
	}
)

let isRefreshTokenFetching = false
let failedApis = []

const processQueue = (error, token = null) => {
	failedApis.forEach((prom) => {
		if (error) {
			prom.reject(error)
		} else {
			prom.resolve(token)
		}
	})

	failedApis = []
}

Request.interceptors.response.use(
	(response) => {
		return response
	},
	async (error) => {
		try {
			const status = error?.response?.status
			const errorData = error?.response?.data
			const requestData = error?.config
			if (status === 404) {
				//file not found/file is deleted -> this will open a popup
				store?.dispatch(setIsFileDeleted(true))
			}
			if (errorData?.detail === "Invalid token or expired token." && status === 401 && !requestData?._retry) {
				if (error?.response?.config?.url?.includes("/auth/refresh-token")) {
					store?.dispatch(logoutClearStore())
					store?.dispatch(logoutUserAction())
					store?.dispatch(logoutUser())
					clearLocalStorage()
					store?.dispatch(clearMultibase())
					return Promise.reject(error)
				}
				if (isRefreshTokenFetching) {
					return new Promise(function (resolve, reject) {
						failedApis.push({ resolve, reject })
					})
						.then((token) => {
							requestData.headers["Authorization"] = "Bearer " + token
							requestData.headers["auth_token"] = token
							requestData.headers["auth-token"] = token
							return Request(requestData)
						})
						.catch((err) => {
							return Promise.reject(err)
						})
				}
				requestData._retry = true
				isRefreshTokenFetching = true

				return new Promise(function (resolve, reject) {
					const user = JSON.parse(localStorage.getItem("user"))
					const projectId = JSON.parse(localStorage.getItem("selectedProject"))
					let projectIdSelected
					if (projectId) {
						projectIdSelected = projectId?.project_id
					} else {
						const available_projects = user?.token?.available_projects
						if (available_projects) {
							projectIdSelected = user?.token?.available_projects[0]?.project_id
						} else {
							projectIdSelected = 0
						}
					}
					const token = user ? user?.token?.refresh_token : undefined
					Request.post(`/auth/refresh-token?project_id=${projectIdSelected}`, {
						grant_type: token,
					})
						.then((response) => {
							const userData = JSON.parse(localStorage.getItem("user"))
							const newToken = response?.data?.token
							userData.token.access_token = newToken
							localStorage.setItem("user", JSON.stringify(userData))
							store?.dispatch(updateToken(userData)) //update store
							store?.dispatch(setAIBaseRequestSuccess(newToken))
							Request.defaults.headers.common["Authorization"] = "Bearer " + newToken
							requestData.headers["Authorization"] = "Bearer " + newToken
							processQueue(null, newToken)
							resolve(Request(requestData))
						})
						.catch((err) => {
							processQueue(err, null)
							store?.dispatch(logoutClearStore())
							store?.dispatch(logoutUserAction())
							store?.dispatch(logoutUser())
							clearLocalStorage()
							store?.dispatch(clearMultibase())
							console.log("Expired Token")
							reject(err)
						})
						.then(() => {
							isRefreshTokenFetching = false
						})
				})
			}
		} catch (e) {
			store?.dispatch(logoutClearStore())
			store?.dispatch(logoutUserAction())
			store?.dispatch(logoutUser())
			clearLocalStorage()
			store?.dispatch(clearMultibase())
			return Promise.reject(e)
		}
		return Promise.reject(error)
	}
)

export default Request
